import { PLATFORM } from '@/const/types/platform';

export const PLATFORM_MAP = {
    [PLATFORM.ANDROID]: 'Android',
    [PLATFORM.IOS]: 'iOS',
}
export const PLATFORM_SELECT = (() => {
    return Object.keys(PLATFORM_MAP).map((key: any) => {
        return {
            label: PLATFORM_MAP[key as PLATFORM],
            value: Number.parseInt(key),
        }
    })
})();